var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#222",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#play_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.44 29.036c4.525 2.65 4.525 9.277 0 11.928L32.347 51.567c-4.524 2.65-10.179-.663-10.179-5.964V24.397c0-5.301 5.655-8.615 10.179-5.964L50.44 29.036Zm-2.261 7.952c1.508-.884 1.508-3.092 0-3.976L30.084 22.41c-1.508-.883-3.393.22-3.393 1.988v21.206c0 1.767 1.885 2.871 3.393 1.988l18.095-10.603Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "play_svg__a",
    x: 19.167,
    y: 14.5,
    width: 39.667,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2429_74223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2429_74223",
    result: "shape"
  })))));
};
export { SvgPlay as ReactComponent };
export default "<svg width=\"70\" height=\"70\" viewBox=\"0 0 70 70\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"70\" height=\"70\" rx=\"35\" fill=\"#222222\" fill-opacity=\"0.5\"/>\n    <g filter=\"url(#filter0_d_2429_74223)\">\n    <path d=\"M50.4409 29.036C54.9646 31.6868 54.9646 38.3132 50.4409 40.964L32.3456 51.567C27.8218 54.2178 22.167 50.9045 22.167 45.6031L22.167 24.3969C22.167 19.0955 27.8218 15.7822 32.3456 18.433L50.4409 29.036ZM48.179 36.9877C49.6867 36.1041 49.6867 33.8959 48.179 33.0123L30.0837 22.4092C28.5758 21.5256 26.6908 22.6298 26.6908 24.3969L26.6908 45.6031C26.6908 47.3702 28.5758 48.4744 30.0837 47.5908L48.179 36.9877Z\" fill=\"white\"/>\n    </g>\n    <defs>\n    <filter id=\"filter0_d_2429_74223\" x=\"19.167\" y=\"14.5\" width=\"39.667\" height=\"43\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n    <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset dx=\"1\" dy=\"1\"/>\n    <feGaussianBlur stdDeviation=\"2\"/>\n    <feComposite in2=\"hardAlpha\" operator=\"out\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0\"/>\n    <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2429_74223\"/>\n    <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2429_74223\" result=\"shape\"/>\n    </filter>\n    </defs>\n</svg>";